import React, { useEffect, useState } from 'react'
import { Avatar, Button, Input, message, Select, Table, Tag } from 'antd'
import axios from 'axios';
import { SERVER_ADDRESS } from '../../Config/Config';
import { EyeOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const UnderVerification = () => {

    const [user,setUser] = useState([]);
    const userData = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
    const userPermission = userData.privelege || []
    const [searchTerm,setSearchTerm] = useState(null);
    const [gender,setGender] = useState(null);
    const [filterUser,setFilterUser] = useState([]);
    const navigate = useNavigate();

    const handleNavige = (id)=>{
        navigate(`/viewUser/${id}`)
    }

    const columns = [
        {
            title:"Id",
            dataIndex:"id",
            key:"id",
            sorter:(a,b)=>a.id - b.id
        },
        {
            title:"Profile",
            dataIndex:"profile",
            key:"profile",
            render:(_,record)=>{
               return record.profile ? (
                    <Avatar src={record.profile} size={64} />
                ) : (
                    <Avatar icon={<UserOutlined />} size={64} />
                )
            }
        },
        {
            title:"Name",
            dataIndex:"name",
            key:"name",
            sorter:(a,b)=>a.name.localeCompare(b.name)
        },
        {
            title:"Gender",
            dataIndex:"gender",
            key:"gender",
            render:(_,record)=>{
                return record.gender === '1' ? (
                    <Tag color='blue' >Groom</Tag>
                ) : (
                    <Tag color='magenta'>Bride</Tag>
                )
            }
        },
        {
            title:"Email",
            dataIndex:"email",
            key:"email"
        },
        {
            title:"Phone",
            dataIndex:"phone",
            key:"phone"
        },
        {
            title:"Option",
            dataIndex:"",
            key:"option",
            render:(_,record)=>{
                return (
                    <>
                    {userPermission.includes("verification") && (<Button color="primary" variant='filled' onClick={(()=>handleNavige(record.id))} ><EyeOutlined /></Button>)}
                    </>
                )
            }
        },
    ]

    const fetchUsers = async()=>{
        try {   
            const response = await axios.post(`${SERVER_ADDRESS}/api/verificationUsers`,{
                type:"1"
            });
            if(response.status === 200){
                const data = response.data.data
                setUser(data);
                setFilterUser(data)
            }
        } catch (error) {
            message.error({content:"Oops! Something went wrong",duration:2})           
        }
    }

    useEffect(()=>{
        fetchUsers();
    },[])

    useEffect(()=>{
        applyFilter();
    },[searchTerm,gender]);

    const applyFilter = ()=>{
        let filtered = user;
        if(searchTerm === ''){
            setFilterUser(filtered)
        }
        else if(searchTerm){
            filtered = filtered.filter((user)=>{
                user.name.toLowerCase().includes(searchTerm.toLowerCase())
            })
        }
        if (gender !== null) {
            filtered = filtered.filter((user) => user.gender == gender);
        }
        setFilterUser(filtered)
    }

    const genderOption =[
        {
            label:"Groom",
            value:'1'
        },
        {
            label:"Bride",
            value:"2"
        }
    ]


  return (
    <>
    <div style={{marginTop:'4rem'}} >
        <h3 className='mb-5' >Under Verification Users</h3>
        <div className='d-flex flex-row gap-4 mb-3' >
                <Input style={{width:'14rem'}} onChange={(e)=>setSearchTerm(e.target.value)} placeholder='Search By Name' prefix={<SearchOutlined />} />
                <Select style={{width:'14rem'}} onChange={(e)=>setGender(e)} options={genderOption} placeholder='Select by Gender' />
        </div>
        <Table columns={columns} rowKey={"id"} dataSource={filterUser} />
    </div>
    </>
  )
}

export default UnderVerification